<template>
  <v-btn-toggle
    v-model="viewMode"
    mandatory
    dense
    color="primary"
    borderless
  >
    <v-btn
      small
      value="chart"
    >
      <v-icon small>
        fal fa-analytics
      </v-icon>
    </v-btn>
    <v-btn
      small
      value="table"
    >
      <v-icon small>
        fal fa-bars
      </v-icon>
    </v-btn>
  </v-btn-toggle>
</template>

<script>

export default {
  name: 'VisualListToggle',
  props: {
    value: {
      type: String,
      default: 'chart'
    }
  },
  data() {
    return {
    }
  },
  computed: {
    viewMode: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    }
  }
}

</script>

<style scoped>

</style>
